import axios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";

const PUBLIC_BASE_URL = process.env.REACT_APP_PUBLIC_BASE_URL;

const axiosConfig = {
    headers: {
        "Content-Type": "application/json",
    },
    withCredentials: true,
};

const handleAxiosError = (err, rejectWithValue) => {
    if (err.message === "Network Error") {
        return rejectWithValue({ message: "Network Error" });
    }
    return rejectWithValue(
        err.response?.data || { message: "Something went wrong" }
    );
};

export const createCertificateEntity = createAsyncThunk(
    "certificate/createCertificateEntity",
    async (formData, { rejectWithValue }) => {
        try {
            const response = await axios.post(
                `${PUBLIC_BASE_URL}/certificate-entities/create-certificate-entity`,
                formData,
                axiosConfig
            );
            return response.data;
        } catch (err) {
            return handleAxiosError(err, rejectWithValue);
        }
    }
);

export const getAllCertificateEntities = createAsyncThunk(
    "certificate/getAllCertificateEntities",
    async ({ skip, limit, search }, { rejectWithValue }) => {
        try {

            const params = {
                ...(skip != null && { skip }),
                ...(limit != null && { limit }),
                ...(search?.trim() && { search }),
            };

            const response = await axios.get(
                `${PUBLIC_BASE_URL}/certificate-entities`,
                {
                    ...axiosConfig,
                    params,
                }
            );
            return response.data;
        } catch (err) {
            return handleAxiosError(err, rejectWithValue);
        }
    }
);

export const updateCertificateEntity = createAsyncThunk(
    "certificate/updateCertificateEntity",
    async (formData, { rejectWithValue }) => {
        try {
            const response = await axios.put(
                `${PUBLIC_BASE_URL}/certificate-entities/update-certificate-entity-info`,
                formData,
                axiosConfig
            );
            return response.data;
        } catch (err) {
            return handleAxiosError(err, rejectWithValue);
        }
    }
);

export const getActiveCertificateEntities = createAsyncThunk(
    "certificate/getActiveCertificateEntities",
    async (_, { rejectWithValue }) => {
        try {

            const response = await axios.get(
                `${PUBLIC_BASE_URL}/certificate-entities/active-certificate-entities`,
                {
                    ...axiosConfig,
                }
            );
            return response.data;
        } catch (err) {
            return handleAxiosError(err, rejectWithValue);
        }
    }
);